const loginInfoKey = '_login_info';

interface LoginInfo {
    locationName: string;
    username: string;
    password: string;
}

export const saveLoginInfo = (locationName: string, username: string, password: string) =>
    localStorage.setItem(
        loginInfoKey,
        JSON.stringify({
            locationName,
            username,
            password
        })
    );

export const loadLoginInfo = (): Partial<LoginInfo> => JSON.parse(localStorage.getItem(loginInfoKey) || '{}');
export const clearLoginInfo = () => {
    const { locationName } = loadLoginInfo();
    saveLoginInfo(locationName || '', '', '');
};
